import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "besidaMob-chat.icon",
  "use": "besidaMob-chat.icon-usage",
  "viewBox": "0 0 17 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 18\" id=\"besidaMob-chat.icon\"><path d=\"M4 7V5h9v2H4zm0 4V9h6v2H4zm11 4.057V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v10c0 .548.452 1 1 1h9.181L15 15.057zM11.819 16H3c-1.652 0-3-1.348-3-3V3a3 3 0 0 1 3-3h11a3 3 0 0 1 3 3v14.943L11.819 16z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol